<!--
  功能：单因子回测 (客户端专用页面)
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="vanEmpty" v-show="apiLoading">
      <div v-cloak>
        <van-empty v-show="apiLoadingErr"  :description="errmsg" :image="require('@/assets/image/notData.png')" />
        
        <div v-show="!apiLoadingErr" class="wrapper">
          <van-loading class="block" />
        </div>
      </div>
    </div>
    <div v-show="!apiLoading" class="vanEmpty">
      <div class="title">
        <p class="name"><i class="blue_top"></i>回测统计明细</p>
      </div>

      <div ref="hcfx">
        <div class="fc-title-sticky">
          <ul class="fc-title">
            <li></li>
            <li>持有期</li>
            <li>区间均涨幅</li>
            <li>盈亏比</li>
            <li style="text-align: right">上涨概率</li>
          </ul>
        </div>
        <ul class="list" v-for="(item, index) in BacktestAnalysisResult" :key="item.HoldPeriod">
          <li class="zybox-list-left">
            <p class="excellent" v-if="item.HoldPeriod === BestAvgCycle">涨幅</p>
            <p class="probability" v-if="item.HoldPeriod === MaxRiseCycle">概率</p>
          </li>

          <li>{{ item.HoldPeriod }}天</li>
          <li :class="[judgeColor(item.AvgSectionRate)]">
            {{ toFixedNum(item.AvgSectionRate * 100, 2, '%') }}
          </li>
          <li>
            {{ toFixedNum(item.ProfitLossRatio, 2, '') }}
          </li>
          <li style="text-align: right">{{ toFixedNum(item.RiseProbability * 100, 2, '%') }}</li>
        </ul>
      </div>

      <div class="title margin_top12">
        <p class="name"><i class="blue_top"></i>区间涨跌分布</p>
      </div>
      <ul class="nav_box clearfix" v-if="BacktestAnalysisResult.length > 0">
        <li
          v-for="(item, index) in BacktestAnalysisResult"
          :key="index"
          :class="index === lsId ? 'active' : ''"
          @click="setChartPie(index)"
        >
          {{ item.HoldPeriod }}天
        </li>
      </ul>
      <div class="lsmxChart" v-show="BacktestAnalysisResult && BacktestAnalysisResult.length">
        <div id="chartLs" class="chartLs"></div>
        <ul class="right">
          <li v-for="(item, index) in pieExplain" :key="index">
            <p><i class="dot" :style="{ background: colorList[index] }"></i>{{ item.name }}</p>
            <p>
              {{ toFixedNum(RiseFallMap[index] * 100, 2, '%') }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { initiateHcByFactor } from '@/api/create.js';
import { judgeColor, toFixedNum } from '@/utils/format';
export default {
  // 组件名称
  name: 'demo',
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      factorid: '', // 客户端传来的因子ID 或者 板板块D
      BacktestAnalysisResult: [], // 显示的内容
      BestAvgCycle: 0,
      MaxRiseCycle: 0,
      lsId: 0,
      pieExplain: [
        {
          name: '大于7.5%'
        },
        {
          name: '3.5%到7.5%'
        },
        {
          name: '0到3.5%'
        },
        {
          name: '-3.5%到0%'
        },
        {
          name: '-3.5%到-7.5%'
        },
        {
          name: '小于-7.5%'
        }
      ],
      colorList: [
        'rgba(255, 99, 99, 1)',
        'rgba(255, 99, 99, 0.6)',
        'rgba(255, 99, 99, 0.4)',
        'rgba(47, 200, 123, 0.4)',
        'rgba(47, 200, 123, 0.6)',
        'rgba(47, 200, 123, 1)'
      ],
      RiseFallMap: [],
      pianChart: null,
      //
      apiLoading: true,
      errmsg: '数据加载中...',
      apiLoadingErr:false,
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    judgeColor,
    toFixedNum,
    initiateDyzHcFun: function () {
      initiateHcByFactor({ factorid: this.factorid })
        .then((result) => {
          if (result.err == 200) {
            // 打开遮罩
            this.apiLoading = false;
            this.apiLoadingErr = false;
            this.BacktestAnalysisResult = result.data.BacktestAnalysisResult;
            this.BestAvgCycle = result.data.ReportGradeResult.BestAvgCycle;
            this.MaxRiseCycle = result.data.ReportGradeResult.MaxRiseCycle;
            result.data.BacktestAnalysisResult.forEach((element, index) => {
              if (result.data.ReportGradeResult.BestAvgCycle == element.HoldPeriod) {
                this.lsId = index;
              }
            });
            this.chartFn(this.lsId);
          } else {
            this.errmsg = result.msg;
            this.apiLoading = true;
            this.apiLoadingErr = true;
          }
        })
        .catch((err) => {
          this.errmsg = '数据加载中';
          this.apiLoading = true;
          this.apiLoadingErr = true;
        });
    },
    // 选中
    setChartPie: function (index) {
      this.lsId = index;
      this.chartFn(index);
    },
    resizeHandler: function () {
      if (this.lineChart) {
        this.lineChart.resize();
      }
      if (this.pianChart) {
        this.pianChart.resize();
      }
      if (this.radarChart) {
        this.radarChart.resize();
      }
    },
    // pain
    chartFn: function () {
      let that = this;
      if (!that.pianChart && that.BacktestAnalysisResult) {
        that.pianChart = that.$echarts.init(document.getElementById('chartLs'));
        window.addEventListener('resize', that.resizeHandler);
      }
      let data = that.BacktestAnalysisResult[that.lsId].RiseFallMap;
      data = data.slice(1);
      data = data.slice(0, -1);
      data = data.split(',');
      that.RiseFallMap = data;
      let option = {
        series: [
          {
            type: 'pie',
            radius: '100%',
            color: that.colorList,
            data: data,
            emphasis: {
              scale: false // 禁止点击放大效果
            },
            label: {
              show: false // 隐藏坐标值
            }
          }
        ]
      };
      option && that.pianChart.setOption(option);
    }
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
   * 在实例初始化之后，组件属性计算之前，如data属性等
   */
  beforeCreate() {},
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {
    let themeStyleVs = Number(this.getUrlQuery('themeStyleVs'));
    if (themeStyleVs === 2) {
      document.querySelector('html').style.background = '#0C0F13';
      document.querySelector('body').setAttribute('style', 'background-color:#0C0F13;');
      document.querySelector('#app').setAttribute('style', 'background-color:#0C0F13;');
    }
  },
  /**
   * 在挂载开始之前被调用：相关的 render 函数首次被调用。
   */
  beforeMount() {},
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted() {
    // 获取路由中的 factorid
    this.factorid = this.$route.query.factorid;
    this.initiateDyzHcFun();
  },
  /**
   * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
   * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
   */
  beforeUpdate() {},
  /**
   * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
   * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
   */
  updated() {},
  /**
   * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
   */
  activated() {},
  /**
   * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
   */
  deactivated() {},
  /**
   * 实例销毁之前调用。在这一步，实例仍然完全可用。
   */
  beforeDestroy() {},
  /**
   * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
   * 所有的事件监听器会被移除，所有的子实例也会被销毁。
   */
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--使用了scoped属性之后，父组件的style样式将不会渗透到子组件中，-->
<!--然而子组件的根节点元素会同时被设置了scoped的父css样式和设置了scoped的子css样式影响，-->
<!--这么设计的目的是父组件可以对子组件根元素进行布局。-->
<style lang="less" scoped>
.index-info {
  padding: 15px;
  .margin_top12 {
    margin-top: 12px;
  }
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
    .name {
      flex-shrink: 0;
    }
    p {
      font-weight: 600;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.9);
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-start;
      align-items: center;
    }
    .blue_top {
      width: 4px;
      height: 16px;
      display: inline-block;
      // border: 1px solid red;
      background: linear-gradient(225deg, #2f94f4 0%, #1c65f7 100%);
      border-radius: 33px;
      margin-right: 6px;
    }
  }
  .fc-title-sticky {
    ::v-deep {
      .van-sticky--fixed {
        left: 15px;
        right: 15px;
      }
    }
  }
  .fc-title {
    display: flex;
    align-items: center;
    // border-top: 1px solid #f0f0f0;
    padding: 4px 0;
    background: #fff;
    width: 100%;
    li {
      font-weight: 400;
      font-size: 12px;
      color: #999;
      &:nth-child(1) {
        width: 16%;
      }
      &:nth-child(2) {
        width: 21%;
      }
      &:nth-child(3) {
        width: 26%;
      }
      &:nth-child(4) {
        width: 21%;
      }
      &:nth-child(5) {
        width: 16%;
      }
    }
  }
  .zybox-list-left {
    // border: 1px solid red;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
  }

  .list {
    display: flex;
    align-items: center;
    border-top: 1px solid #f0f0f0;
    li {
      font-weight: 400;
      font-size: 14px;
      color: #222;
      padding: 12px 0;
      &:nth-child(1) {
        width: 16%;
      }
      &:nth-child(2) {
        width: 21%;
      }
      &:nth-child(3) {
        width: 26%;
      }
      &:nth-child(4) {
        width: 21%;
      }
      &:nth-child(5) {
        width: 16%;
      }

      .excellent,
      .probability {
        // flex-shrink: 0;
        // width: 28px;
        // height: 16px;
        // line-height: 16px;
        // border-radius: 2px;
        // font-weight: 400;
        // font-size: 10px;
        // color: #fff;
        // text-align: center;
        // padding: 1px 2px;
        // margin: 2px;
        width: 18px;
        height: 30px;
        line-height: 14px;
        display: inline-flex;
        padding: 2px 3px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        color: #fff;
        font-size: 10px;
        font-weight: 400;
        border-radius: 2px;
        margin-right: 4px;
      }
      .excellent {
        background: linear-gradient(270deg, #cd0000 0%, #f76825 100%);
      }
      .probability {
        background: linear-gradient(270deg, #e47813 0%, #ffbe5e 100%);
      }
    }

    &:last-child {
      border-bottom: 1px solid #f0f0f0;
    }
  }

  // 区间涨跌分布
  .nav_box {
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;
    display: flex;
    li {
      width: 50px;
      height: 25px;
      text-align: center;
      line-height: 25px;
      font-size: 12px;
      color: #555;
      border-radius: 4px;
      border: 1px solid #f0f0f0;
      margin-right: 8px;
      flex-shrink: 0;
      &.active {
        border: 1px solid rgba(40, 109, 247, 0.1);
        background: rgba(40, 109, 247, 0.1);
        color: #286df7;
        font-weight: 500;
      }
    }
  }
  .lsmxChart {
    width: 100%;
    padding: 8px 16px 16px 16px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    .chartLs {
      width: 117px;
      height: 117px;
    }
    .right {
      width: 50%;
      height: 142px;
      margin-top: 10px;
      li {
        p {
          font-weight: 400;
          font-size: 12px;
          color: #555;
        }
      }
    }
    .right {
      line-height: 24px;
      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        p {
          display: flex;
          align-items: center;
          .dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            margin-right: 3px;
          }
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.white_theme {
  .vanEmpty {
    height: 100vh;
    width: 100%;
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .block {
      width: 120px;
      height: 120px;
      text-align: center;
    }
  }
}
.black_theme {
  background: #0c0f13;
  .vanEmpty {
    height: 100vh;
    width: 100%;
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }
    .block {
      width: 120px;
      height: 120px;
      text-align: center;
    }
  }
  .title {
    .name {
      color: #e4e9fe;
    }
    .right {
      color: #6b7687;
    }
  }
  .list {
    .right {
      color: #e4e9fe;
    }
  }
  .fc-title-sticky {
    .fc-title {
      background: #191a24;
      border-top: 1px solid #2f3139;
      li {
        color: #6b7687;
      }
    }
  }
  .list {
    border-top: 1px solid #2f3139;
    &:last-child {
      border-bottom: 1px solid #2f3139;
    }
    li {
      color: #e4e9fe;
    }
  }
  .nav_box {
    li {
      color: #aab9d1;
      border: 1px solid var(--colours-line-4, rgba(255, 255, 255, 0.2));
    }
  }

  .lsmxChart {
    .right {
      li {
        p {
          color: #aab9d1;
        }
      }
    }
  }
}
</style>
